import { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";

export default function ConfirmationModal({
  setModalState,
  title,
  description,
  confirmed,
  confirmButtonText,
  showModal = false,
}) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    setShow(showModal);
  }, [showModal]);

  const handleClose = () => {
    setShow(false);
    setModalState(false);
  };

  const handleConfirm = () => {
    setShow(false);
    setModalState(false);
    confirmed();
  };

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Body className="d-flex flex-column p-4">
          <div className="text-center">
            <span className="fs-3 fw-bold">{description}</span>
          </div>
          <div className="d-flex justify-content-between mt-3">
            <Button variant="outline-dark" onClick={handleClose}>
              cancel
            </Button>
            <Button variant="danger" onClick={handleConfirm}>
              {confirmButtonText}
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
